import { render, staticRenderFns } from "./RangeComponent.vue?vue&type=template&id=b52d4a6c&scoped=true&"
import script from "./RangeComponent.vue?vue&type=script&lang=js&"
export * from "./RangeComponent.vue?vue&type=script&lang=js&"
import style0 from "./RangeComponent.vue?vue&type=style&index=0&id=b52d4a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52d4a6c",
  null
  
)

export default component.exports